<template>
  <div>
    <div class="mb-4 text-subtitle-2">
      <span class="secondary-font font-weight-bold">{{
        $t("distributors.transfers.title")
      }}</span>
    </div>
    <v-card class="elevation-0" color="rgba(255,255,255,0)">
      <v-card-actions class="px-0 mb-2">
        <v-btn
          depressed
          @click="refreshItems()"
          :disabled="loading.filter"
          color="grey lighten-2"
          :loading="loading.refresh"
        >
          <v-icon left>mdi-refresh</v-icon>
          {{ $t("btn.refresh") }}
        </v-btn>
        <v-btn
          @click="getFilter()"
          depressed
          :loading="loading.filter"
          color="grey lighten-2"
          class="mr-2"
        >
          <v-icon left>mdi-filter-variant</v-icon>
          {{ $t("btn.filter") }}
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-card class="elevation-1">
      <v-card-title>
        <span class="text-body-1">
          <span class="secondary-font font-weight-bold">{{
            $t("distributors.transfers.list.title")
          }}</span>
        </span>
      </v-card-title>
      <v-divider></v-divider>
      <v-data-table
        :headers="headers"
        :items="items"
        :server-items-length="meta.total"
        :loading="loading.list"
        :items-per-page="itemPerPage"
        :options.sync="pagination"
        :sort-by="sortBy"
        :sort-desc="sortDesc"
        :footer-props="footerProps"
      >
        <template v-slot:body="{ items }" v-if="!_.isEmpty(items)">
          <tbody>
            <template v-for="item in items">
              <v-hover :key="item.id" v-slot:default="{ hover }">
                <tr>
                  <td style="min-width: 160px">
                    {{ $moment(item.created).format("YYYY-MM-DD HH:mm:ss") }}
                  </td>
                  <td v-if="$auth.check(['ROLE_ADMIN'])">
                    {{ item.application.user.username }}
                  </td>
                  <td>{{ item.amount }}</td>
                  <td>
                    <v-chip
                      class="table-chips text-body-2"
                      color="success"
                      v-if="item.status === 'SUCCESS'"
                    >
                      <span>{{
                        $t(`commons.fields.status.${item.status}`)
                      }}</span>
                    </v-chip>
                    <v-chip
                      class="table-chips text-body-2"
                      color="primary"
                      v-else-if="item.status === 'TRANSIENT'"
                    >
                      <span>{{
                        $t(`commons.fields.status.${item.status}`)
                      }}</span>
                    </v-chip>
                    <v-chip
                      class="table-chips text-body-2"
                      color="error"
                      v-else
                    >
                      <span>{{
                        $t(`commons.fields.status.${item.status}`)
                      }}</span>
                    </v-chip>
                  </td>
                  <td>{{ item.destination_dist_name }}</td>
                  <td>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          @click="getDetails(item)"
                          x-small
                          icon
                          v-bind="attrs"
                          v-on="on"
                          v-show="hover || $vuetify.breakpoint.mdAndDown"
                        >
                          <v-icon color="primary">mdi-eye-outline</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t("btn.details") }}</span>
                    </v-tooltip>
                  </td>
                </tr>
              </v-hover>
            </template>
          </tbody>
        </template>
      </v-data-table>
    </v-card>
    <transfer-details
      :transfer="transfer"
      :dialog="dialog.details"
    ></transfer-details>
    <transfer-filter
      @filter="applyFilter"
      :dialog="dialog.filter"
    ></transfer-filter>
  </div>
</template>

<script>
import TransferDetails from "./details";
import TransferFilter from "./filter";
import ListMixin from "./../../../mixins/commons/list";

export default {
  mixins: [ListMixin],
  data: () => ({
    url_items: "/api/mynetwork/distributors/transfers",
    dialog: {
      details: {
        display: false,
      },
      filter: {
        display: false,
      },
    },
    transfer: {},
  }),
  methods: {
    setHeaders() {
      const headers = [
        {
          text: this.$t("commons.fields.created.title"),
          align: "start",
          sortable: true,
          value: "created",
          width: 160,
        },
      ];
      if (this.$auth.check(["ROLE_ADMIN"])) {
        headers.push({
          text: this.$t("commons.fields.account.title"),
          align: "start",
          sortable: false,
          value: "application.user.username",
          width: 90,
        });
      }
      this.headers = [
        ...headers,
        {
          text: this.$t("commons.fields.amount.title"),
          align: "start",
          sortable: false,
          value: "amount",
          width: 80,
        },
        {
          text: this.$t("commons.fields.status.title"),
          align: "start",
          sortable: false,
          value: "status",
          width: 80,
        },
        {
          text: this.$t("commons.fields.distributor_name.title"),
          align: "start",
          sortable: false,
          value: "destination_dist_name",
        },
        {
          text: "",
          align: "start",
          sortable: false,
          value: null,
          width: 60,
        },
      ];
    },
    getDetails(transfer) {
      this.transfer = transfer;
      this.dialog.details.display = true;
    },
    getFilter() {
      this.dialog.filter.display = true;
    },
  },
  components: {
    TransferDetails,
    TransferFilter,
  },
};
</script>
